import { lazy } from "react";
import {
  enumPermisosGestionBCS,
} from "./enumPermisosGestionBCS";
/** Componente de iconos */
const AppIcons = lazy(() => import("../../components/Base/AppIcons"));

/**
 * Corresponsalia tu llave
 */
const ComerciosRechazadosBCS = lazy(() =>
  import("./Views/ComerciosBCS/ComerciosRechazados")
);

const ComerciosCanceladasBCS = lazy(() =>
  import("./Views/ComerciosCanceladasBCS/ComerciosCancelados")
);

const CancelarBloquearComerciosBCS = lazy(() =>
  import("./components/ConsultaComerciosCancelados/BloqueoActiveCommerce")
);

const ConveniosBCS = lazy(() =>
  import("./Views/Convenios/Convenios")
);

const GestionBCS = lazy(() =>
  import("./GestionBCS")
);

const CreacionComerciosBCS = lazy(() =>
  import("./Views/CreacionComerciosBCS/CreacionComercios")
);

const CreacionTerminalesBCS = lazy(() =>
  import("./Views/CreacionTerminalesBCS/CreacionTerminales")
);

const listPermissions = Object.values(enumPermisosGestionBCS);

export const listPermissionsGestionBCS = listPermissions;

const routesBcs = {
  link: "/GestionTransaccional/gestion-banco-caja-social",
  label: <AppIcons Logo={"CAJA_SOCIAL"} name='Gestión BCS' />,
  component: GestionBCS,
  permission: [enumPermisosGestionBCS.GESTION_BCS],
  subRoutes: [
    {
      link: "/GestionTransaccional/gestion-banco-caja-social/comercios-rechazados",
      label: <AppIcons Logo={"BLOQUEO_COMERCIO_BCS"} name={"Comercios Rechazados"} />,
      component: ComerciosRechazadosBCS,
      permission: [enumPermisosGestionBCS.COMERCIOS_RECHAZADOS_BCS],
    },
    {
      link: "/GestionTransaccional/gestion-banco-caja-social/convenios",
      label: <AppIcons Logo={"BLOQUEO_COMERCIO_BCS"} name={"Convenios Recaudo BCS"} />,
      component: ConveniosBCS,
      permission: [enumPermisosGestionBCS.CONVENIOS_BCS],
    },
    {
      link: "/GestionTransaccional/gestion-banco-caja-social/creacion-comercios",
      label: <AppIcons Logo={"BLOQUEO_COMERCIO_BCS"} name={"Creación Comercios BCS"} />,
      component: CreacionComerciosBCS,
      permission: [enumPermisosGestionBCS.CREACION_COMERCIOS_BCS],
    },
    {
      link: "/GestionTransaccional/gestion-banco-caja-social/creacion-terminales",
      label: <AppIcons Logo={"BLOQUEO_COMERCIO_BCS"} name={"Creación Terminales BCS"} />,
      component: CreacionTerminalesBCS,
      permission: [enumPermisosGestionBCS.CREACION_TERMINALES_BCS],
    },
    {
      link: "/GestionTransaccional/gestion-banco-caja-social/comercios-cancelados",
      label: <AppIcons Logo={"BLOQUEO_COMERCIO_BCS"} name={"Cancelación y Bloqueo Interno Comercios BCS"} />,
      component: ComerciosCanceladasBCS,
      permission: [enumPermisosGestionBCS.COMERCIOS_CANCELADOS_BCS],
      subRoutes: [
        {
          link: "/GestionTransaccional/gestion-banco-caja-social/comercios-cancelados/crear",
          label: <AppIcons Logo={"BLOQUEO_COMERCIO_BCS"} name="Cancelación y Bloqueo Interno Comercios BCS" />,
          component: CancelarBloquearComerciosBCS,
          permission: [enumPermisosGestionBCS.COMERCIOS_CANCELADOS_BCS],
        }
      ]
    },
  ],
};

export default routesBcs;
